import React from 'react';
import { Container } from './ui/Container';
export function ReasonWhySection() {
  return <section className="py-16 bg-white" data-id="element-395">
      <Container className="max-w-4xl text-center" data-id="element-396">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-397">
          Why SnoreStop™ Works When Everything Else Failed
        </h2>
        <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-8" data-id="element-398">
          Most solutions are uncomfortable, expensive, or just don't work.
          SnoreStop™ uses a simple
          <span className="font-bold text-blue-800" data-id="element-399">
            {' '}
            jaw-positioning design
          </span>{' '}
          that opens your airways naturally—no machines, no surgery, no pills.
          Just quiet, peaceful sleep from night one.
        </p>
        <div className="inline-block bg-blue-50 px-6 py-3 rounded-lg border border-blue-100" data-id="element-400">
          <p className="text-blue-800 font-semibold" data-id="element-401">
            Thousands of couples are already sleeping together again. Join them
            tonight.
          </p>
        </div>
      </Container>
    </section>;
}